/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoCuentaBancaria from 'Infotrack@Modelos/administracion/tipoCuentaBancaria/entidades/tipoCuentaBancaria';
import React from 'react';
import TipoCuentaBancariaCM from '../controladorModelo/tipoCuentaBancariaCM';
import { acciones, IEstadoTipoCuentaBancaria } from '../reductorTipoCuentaBancaria';
import FormularioTipoCuentaBancariaVista from '../vista/formularioTipoCuentaBancariaVista';

const estadoInicial: ITipoCuentaBancaria = {
    CodigoTipoCuentaBancaria: '',
    NombreTipoCuentaBancaria: '',
    EstadoTipoCuentaBancaria: true,
};
const tipoCuentaBancariaCM = new TipoCuentaBancariaCM();

const FormularioTipoCuentaBancariaCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadTipoCuentaBancaria }, dispatch] = useProveedor<
        IEstadoTipoCuentaBancaria
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITipoCuentaBancaria>(estadoInicial);

    React.useEffect(() => {
        if (entidadTipoCuentaBancaria && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTipoCuentaBancaria);
        } else {
            reiniciar();
        }
    }, [entidadTipoCuentaBancaria]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };

    const confirmarCreacionEdicionTipoCuentaBancaria = () => {
        if (tipoCuentaBancariaCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTipoCuentaBancaria,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTipoCuentaBancaria = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tipoCuentaBancariaCM.crearTipoCuentaBancaria(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            tipoCuentaBancariaCM.editarTipoCuentaBancaria(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioTipoCuentaBancariaVista
            accionCrearEditar={confirmarCreacionEdicionTipoCuentaBancaria}
            cambiarInfoFomulario={alCambiarValor}
            tipoCuentaBancaria={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioTipoCuentaBancariaCV;
